import { createContext } from "react";
import { SessionIASMA } from "iasma-datatypes";
import { AxiosResponse, AxiosStatic } from "axios";

export interface AuthContextType {
	isLoading: boolean;
	setIsLoading: (loading: boolean) => void;

	session: SessionIASMA | undefined;
	signin: (data: any) => Promise<void>;
	signout: () => Promise<void>;
	setToken: (axios: AxiosStatic) => void;
//	setToken: () => void;
//	updateToken: (token: string) => void;
	hasRole: (role: number) => boolean;
	getRoles: (id?: number) => Promise<any>;
	saveRoles: (data: any) => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
